import { Accordion, Badge, Button, Divider, Flex, Grid, NumberInput, Select, Stack, TextInput, Text, Group, Paper } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconCalendar, IconCoin, IconCurrencyDollar, IconSchool, IconBook, IconBrandDisqus, IconDeviceFloppy, IconBolt } from "@tabler/icons-react";
import { useState } from "react";

export default function AdministrativeUsersTeachersFeeForm(props) {
    const { form, loading } = props;

    const [bulkAmount, setBulk] = useState({
        amount: 0,
        currency: "USD"
    });


    const handleApplyBulkAmount = () => {
        // Obtenemos una copia de las unidades actuales
        const updatedUnits = form.values.academicUnitsData.map(unit => ({
            ...unit,
            lessonsData: unit.lessonsData.map(lesson => ({
                ...lesson,
                fee: {
                    ...lesson.fee,
                    currency: bulkAmount.currency,
                    amount: bulkAmount.amount
                }
            }))
        }));

        // Actualizamos el formulario de una sola vez
        form.setFieldValue('academicUnitsData', updatedUnits);
    };
    return (
        <Grid style={{ width: "100%" }} gutter="xl">
            <Grid.Col span={12}>
                <Paper withBorder p="md" radius="md" bg="blue.0">
                    <Group justify="space-between" align="flex-end">
                        <Stack gap={4}>
                            <Group gap="xs">
                                <IconBolt size={18} color="var(--mantine-color-blue-filled)" />
                                <Text fw={600} size="sm">Carga Masiva</Text>
                            </Group>
                            <Text size="xs" c="dimmed">
                                Define un monto único y moneda para aplicar a todas las clases de este profesor.
                            </Text>
                        </Stack>

                        <Group w='100%' align="flex-end">
                            <NumberInput
                                label="Monto general"
                                placeholder="0.00"
                                value={bulkAmount.amount}
                                onChange={(value) => setBulk(prev => ({ ...prev, amount: value }))}
                                min={0}
                                prefix="$ "
                                hideControls
                            />
                            <Select
                                label="Moneda"
                                allowDeselect={false}
                                value={bulkAmount.currency}
                                onChange={(value) => setBulk(prev => ({ ...prev, currency: value }))}
                                data={["USD", "ARS"]}
                            />
                            <Button
                                variant="filled"
                                color="blue"
                                onClick={handleApplyBulkAmount}
                                leftSection={<IconBolt size={16} />}
                                disabled={bulkAmount.amount < 0 || !bulkAmount.currency}
                            >
                                Aplicar a todo
                            </Button>
                        </Group>
                    </Group>
                </Paper>
            </Grid.Col>

            {form.values.academicUnitsData?.length > 0 ? (
                <Grid.Col span={12}>
                    <Text size="sm" fw={500} mb="xs">Unidades Académicas:</Text>
                    <Text size="xs" fw={500} mb="xs">Haz click en una para ver las clases correspondientes</Text>

                    <Accordion variant="separated" chevronPosition="right">
                        {form.values.academicUnitsData.map((academicUnit, idx) => (
                            <Accordion.Item key={academicUnit._id} value={academicUnit._id}>
                                <Accordion.Control>
                                    <Group gap="sm">
                                        <IconSchool size={20} color="var(--mantine-color-blue-filled)" />
                                        <Text fw={600}>{academicUnit.name}</Text>
                                        <Badge variant="light" size="sm">
                                            {academicUnit.lessonsData?.length} clases
                                        </Badge>
                                    </Group>
                                </Accordion.Control>

                                <Accordion.Panel>
                                    <Stack gap="xl" py="md">
                                        {academicUnit?.lessonsData?.map((lesson, index) => (
                                            <Paper key={lesson.lessonId} withBorder p="md" radius="md" bg="var(--mantine-color-gray-0)">
                                                <Stack gap="sm">
                                                    <Group justify="space-between">
                                                        <Group gap="xs">
                                                            <IconBook size={16} />
                                                            <Text fw={500} size="sm">{lesson.name}</Text>
                                                        </Group>
                                                        <Badge color="gray" variant="outline">Clase #{index + 1}</Badge>
                                                    </Group>

                                                    <Flex
                                                        gap="md"
                                                        direction={{ base: 'column', sm: 'row' }}
                                                        align={{ sm: 'flex-end' }}
                                                    >
                                                        <DateInput
                                                            disabled
                                                            label="Fecha de inicio"
                                                            leftSection={<IconCalendar size={16} />}
                                                            value={lesson.date ? new Date(lesson.date) : null}
                                                            style={{ flex: 1 }}
                                                        />

                                                        <NumberInput
                                                            label="Monto de tarifa"
                                                            placeholder="0.00"
                                                            hideControls
                                                            prefix="$ "
                                                            min={0}
                                                            leftSection={<IconCurrencyDollar size={16} />}
                                                            {...form.getInputProps(`academicUnitsData.${idx}.lessonsData.${index}.fee.amount`)}
                                                            style={{ flex: 1 }}
                                                        />

                                                        <Select
                                                            label="Moneda"
                                                            data={['USD', 'ARS']}
                                                            leftSection={<IconCoin size={16} />}
                                                            {...form.getInputProps(`academicUnitsData.${idx}.lessonsData.${index}.fee.currency`)}
                                                            style={{ flex: 0.5 }}
                                                        />
                                                    </Flex>

                                                </Stack>
                                            </Paper>
                                        ))}
                                    </Stack>
                                </Accordion.Panel>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Grid.Col>
            ) : (
                <Grid.Col span={12}>
                    <Paper p="xl" withBorder style={{ textAlign: 'center' }}>
                        <Text color="dimmed">No se encontraron unidades académicas asignadas a este profesor.</Text>
                    </Paper>
                </Grid.Col>
            )}

            <Grid.Col span={12}>
                <Button
                    type="submit"
                    loading={loading}
                    disabled={loading}
                >
                    Guardar tarifas
                </Button>
            </Grid.Col>
        </Grid>
    );
}